'use client';

import { useEffect, useState } from 'react';
import { InsightForm } from '@/components/admin/insights/InsightForm';
import { getFootprints } from '@/lib/actions/footprints';
import { getServiceCategories } from '@/lib/actions/service-categories';

export default function AdminInsightNewPage() {
  const [footprints, setFootprints] = useState<Awaited<ReturnType<typeof getFootprints>>>([]);
  const [serviceCategories, setServiceCategories] = useState<Awaited<ReturnType<typeof getServiceCategories>>>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([getFootprints(), getServiceCategories()]).then(([footprintsData, categoriesData]) => {
      setFootprints(footprintsData);
      setServiceCategories(categoriesData);
      setLoading(false);
    });
  }, []);

  if (loading) {
    return null;
  }

  return <InsightForm allFootprints={footprints} serviceCategories={serviceCategories} />;
}
